module.exports = __webpack_public_path__ + "img/Arma 3 Unit Newfound Pioneer Corps Modpack step 3.c0fff192.webp";